import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from '@martinjlowm/react-hook-form';
import { Button, CardActions, CardContent, CardHeader, Grid, TextField } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import z from 'zod';

import { forgotPasswordSchema } from './schemas';

export type FormValues = z.infer<typeof forgotPasswordSchema>;

export interface Properties {
  onSubmit: (form: FormValues) => void;
  onCancel: () => void;
  defaultValues?: Partial<FormValues>;
}

const resolver = zodResolver(forgotPasswordSchema);

const ResetPassword: FC<Properties> = ({ onSubmit, onCancel, defaultValues }) => {
  const { t } = useTranslation('auth');

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<FormValues>({
    mode: 'onChange',
    defaultValues,
    resolver,
  });

  const resetPasswordTitle = t('auth:forgotPasswordTitle', 'Forgot Password');

  const propagateForm = handleSubmit(onSubmit);

  return (
    <form onSubmit={propagateForm}>
      <CardHeader
        titleTypographyProps={{ align: 'center' }}
        subheaderTypographyProps={{ align: 'center' }}
        title={resetPasswordTitle}
        subheader={t(
          'auth:forgotPasswordGuidance',
          'Please enter your e-mail address to receive instructions for resetting your password or to get new verification code if you are yet to sign up and your current code has expired.',
        )}
      />
      <CardContent>
        <Grid container item xs={12}>
          <TextField
            autoFocus
            fullWidth
            type="email"
            autoComplete="username"
            error={'email' in errors}
            required
            label={t('auth:email', 'E-mail')}
            {...register('email')}
          />
        </Grid>
      </CardContent>
      <CardActions sx={{ p: 2 }}>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item xs={12}>
            <Button fullWidth disabled={!isValid} variant="contained" color="primary" type="submit">
              {resetPasswordTitle}
            </Button>
          </Grid>
          <Grid item>
            <Button color="primary" onClick={onCancel}>
              {t('common:returnToLogin', 'Return to login')}
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </form>
  );
};

export default ResetPassword;
